export const STATUS_COLORS = {
  Diterima: "bg-blue-100 text-blue-700 border-blue-200",
  Diverifikasi: "bg-indigo-100 text-indigo-700 border-indigo-200",
  Diproses: "bg-amber-100 text-amber-700 border-amber-200",
  Ditindaklanjuti: "bg-purple-100 text-purple-700 border-purple-200",
  Selesai: "bg-green-100 text-green-700 border-green-200",
  Ditolak: "bg-red-100 text-red-700 border-red-200",
  Draft: "bg-slate-100 text-slate-600 border-slate-200",
  Review: "bg-amber-100 text-amber-700 border-amber-200",
  Approved: "bg-blue-100 text-blue-700 border-blue-200",
  Published: "bg-green-100 text-green-700 border-green-200",
};

export const ROLE_LABELS = {
  SUPER_ADMIN: "Super Admin",
  ADMIN_HUMAS: "Admin Humas",
  VERIFIKATOR: "Verifikator",
  UNIT_KERJA: "Unit Kerja",
};

export const CATEGORY_COLORS = {
  Kegiatan: "bg-blue-50 text-blue-700",
  Pengawasan: "bg-red-50 text-red-700",
  Kelembagaan: "bg-purple-50 text-purple-700",
  Edukasi: "bg-emerald-50 text-emerald-700",
  "Informasi Publik": "bg-amber-50 text-amber-700",
  Pengumuman: "bg-orange-50 text-orange-700",
  Regulasi: "bg-slate-100 text-slate-700",
  Berita: "bg-navy/5 text-navy",
};

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("id-ID", {
      day: "numeric", month: "long", year: "numeric",
    });
  } catch {
    return iso;
  }
}

export function formatDateShort(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}
